module.exports = __webpack_public_path__ + "static/media/img_prn49.25e0b607.png";